import { render, staticRenderFns } from "./InformativaRegistrazionePartner.vue?vue&type=template&id=7744991e&scoped=true&"
import script from "./InformativaRegistrazionePartner.vue?vue&type=script&lang=js&"
export * from "./InformativaRegistrazionePartner.vue?vue&type=script&lang=js&"
import style0 from "./InformativaRegistrazionePartner.vue?vue&type=style&index=0&id=7744991e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7744991e",
  null
  
)

export default component.exports